import PropTypes from "prop-types";
import { BbotAlert, SettingsCard, Space } from "top-component-library";
import StationScheduleCard from "./StationScheduleCard";
import TechSupportQuestions from "../TechSupportQuestions";

// Tab 1: per-station weekly hours. When the customer is forced into order-ahead,
// the legacy page disabled this tab entirely, so we show a notice instead.
const PrepStationAvailabilityTab = ({ stations, forceAllowOrderAhead, techSupportContact, onSaveStation }) => {
  if (forceAllowOrderAhead) {
    return (
      <BbotAlert message="Prep station availability is currently managed by your order-ahead configuration and cannot be edited here." />
    );
  }

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <TechSupportQuestions contact={techSupportContact} />
      <SettingsCard title="Hours prep stations can receive orders">
        <div>
          <p>When should guests see the items fulfilled by each prep station, and be able to order them?</p>
          <p>
            This applies when the TOP by DoorDash Terminal&apos;s &quot;Allow Orders&quot; setting is &quot;BY
            SCHEDULE&quot;. It can be overridden by setting &quot;Allow Orders&quot; to &quot;ON&quot; or
            &quot;OFF&quot;.
          </p>
          <h5>Formatting</h5>
          <p>
            Type 12AM-12AM if open all day.
            <br />
            Type CLOSED if closed all day.
          </p>
          <p>
            <b>Valid examples</b>
            <br />
            &quot;9AM - 2PM, 4PM - 2AM&quot;
            <br />
            &quot;9AM - 2:30AM&quot;
            <br />
            &quot;8:15AM - 2:15AM&quot;.
          </p>
        </div>
      </SettingsCard>
      {stations.map((station) => (
        <StationScheduleCard key={station.station_id} station={station} onSave={onSaveStation} />
      ))}
    </Space>
  );
};

PrepStationAvailabilityTab.propTypes = {
  stations: PropTypes.arrayOf(PropTypes.object).isRequired,
  forceAllowOrderAhead: PropTypes.bool,
  techSupportContact: PropTypes.shape({
    phone: PropTypes.string,
    text: PropTypes.string,
    email: PropTypes.string,
  }),
  onSaveStation: PropTypes.func.isRequired,
};

export default PrepStationAvailabilityTab;
